<template>
    <!-- header -->
    <div>
        <div class="hero full-width">
            <div class="first-column">
                <div class="first-column-content hide-on-small-only">
                    <div class="hide-on-small-only logo">
                        <img :src="pageData.logo" alt="" />
                    </div>
                    <div class="hide-on-small-only title">
                        {{ pageData.name }}
                    </div>
                    <div class="hide-on-small-only subtitle">
                        {{ pageData.subtitle }}
                    </div>
                </div>
            </div>
            <div class="second-column">
                <img :src="pageData.banner" alt="" class="hero-img" />
                <div class="title-section hide-on-med-and-up">
                    <div class="title">
                        {{ pageData.name }}
                    </div>
                    <div class="subtitle">
                        {{ pageData.subtitle }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderOfLadingPageCondo',
    props: {
        pageData: Object
    }
};
</script>

<style>
body {
    overflow-x: hidden;
}
.normal-phone {
    display: none !important;
}
.adwords-phone {
    display: block !important;
}

.container.section {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
}

.dark-blue-header .btn-default {
    font-size: 14px;
}

.whatsapp-icon-btn {
    background-color: #26ade2;
    border: none;
}
.whatsapp-icon {
    width: 20px;
    margin: 0 auto;
    vertical-align: middle;
    display: inline-block;
    margin-left: 11px;
}

.multiselect-label {
    position: relative !important;
    font-size: 0.8rem !important;
}

.hero {
    display: flex;
    height: 720px;
    justify-content: space-between;
    margin-bottom: 52px;
    background-color: white;
    background-image: linear-gradient(white 92%, #372929 114%);
}
.hero .first-column {
    align-items: center;
    display: flex;
    width: 50%;
}
.hero .first-column-content {
    color: #004880;
    display: block;
    margin: 80px auto 54px;
    margin-left: 12%;
    width: 78%;
}
.hero .first-column-content .title {
    font-size: 39px;
    font-style: italic;
    font-weight: 700;
    line-height: 43px;
    margin-bottom: 12px;
    text-align: left;
}
.hero .first-column-content .subtitle {
    font-size: 23px;
    font-style: italic;
    margin-bottom: 54px;
    text-align: left;
}
.hero .first-column-content .btn-container .hero-btn {
    color: white;
    font-size: 21px;
    font-weight: 700;
    padding: 11px 30px;
}
.hero .first-column-content .hero-form-container {
    display: flex;
    justify-content: flex-start;
    color: black;
    margin-bottom: 20px;
}
.hero .first-column-content .hero-form-container div.input-field:first-child {
    margin-right: 8px;
}
.hero .first-column-content .secured {
    align-items: center;
    display: flex;
    font-size: 18px;
    font-style: italic;
    margin-top: 20px;
}
.hero .first-column-content .secured .secured-icon {
    margin-right: 15px;
    width: 32px;
}
.hero .first-column-content .message {
    display: flex;
    flex-direction: column;
}
.hero .second-column {
    width: 58%;
}
.hero-img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.steps,
.steps-pushpin {
    background-color: #eaeaea;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 108px;
    height: 119px;
    align-items: center;
    z-index: 5;
}
.step-content {
    align-items: center;
    display: flex;
    font-style: italic;
    margin: 13px 0;
    text-align: center;
    width: 33%;
    justify-content: space-between;
}
.step-content .content {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.step-content .step-arrow i {
    font-size: 50px;
    color: #6f6f6f;
}
.step-content:first-child {
    margin-left: 37px;
}
.step-content:nth-child(3) {
    margin-right: 37px;
    width: 18%;
}
.step-content .number {
    background-color: #008fff;
    color: white;
    font-size: 17px;
    padding: 4px 12px;
    border-radius: 50%;
}
.step-content .text {
    color: #002b4d;
    font-size: 16px;
    margin-top: 12px;
}

.form-container {
    border: 1px solid #c1c1c1;
    border-radius: 4px;
    margin-bottom: 120px;
    box-shadow: 0 5px 24px 0 #c1c1c1;
    background-color: #f5f5f5;
}
.form-wrapper {
    width: 85%;
    margin: 70px auto 76px;
}
.form-container .title {
    color: #002b4d;
    font-size: 30px;
    font-weight: 500;
    text-align: center;
}
.form-container .subtitle {
    color: #002b4d;
    font-size: 26px;
    font-weight: 400;
    margin-bottom: 56px;
    text-align: center;
}
.form-container .subtitle .free {
    color: #ff7f00;
    font-weight: 500;
}

.profiles-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 65px;
}
.profile {
    align-items: center;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    color: #6a6a6a;
    cursor: pointer;
    display: flex;
    flex: 1 1 30%;
    font-size: 17px;
    font-weight: 600;
    justify-content: center;
    line-height: 13px;
    margin: 0 8px;
    padding: 19px 0;
    text-align: center;
}
.profile:first-child {
    margin-left: 0;
}
.profile:last-child {
    margin-right: 0;
}
.profile--active:hover {
    opacity: 0.8;
}
.profile:hover:not(.profile--active) {
    background-color: #f5f5f5;
}
.profile--active {
    background-color: #008fff;
    border: none;
    color: #fff;
    text-align: center;
}

.attachments-input {
    margin-bottom: 76px;
}
.attachments-info .chip {
    margin-bottom: 6px;
    margin-top: 0;
}

.attachments {
    align-items: center;
    border-radius: 5px;
    border: 1px solid #808080;
    display: flex;
    height: 41%;
    padding: 9px 12px;
    justify-content: space-between;
}
.attachment-label {
    color: #383838;
    width: 50%;
    line-height: 15px;
    font-size: 12px;
}
.attachment-btn {
    background-color: #adadad;
    width: 17%;
    height: 2.2rem !important;
    display: flex;
    justify-content: center;
}
.attachment-btn:hover {
    background-color: #757575;
}
.attachment-spinner .spinner-layer {
    border-color: #065fad;
}
.attach-icon {
    align-self: center;
    font-size: 28px !important;
}

.chip-container {
    overflow-y: auto;
    max-height: 5rem;
    margin-top: 15px;
}
.chip {
    margin: 12px 5px 0;
    background-color: #eaeaea;
    max-width: 44%;
}
.chip .chip-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 250px;
}
.chip .chip-content span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.chip .remove-icon {
    cursor: pointer;
}
.chip-detail {
    background-color: #adf9fc;
}
.chip-detail .chip-content {
    color: #002b4d;
}

.bold-label {
    color: #002b4d !important;
    font-weight: 700;
    font-size: 20px !important;
}

.container-with-label {
    margin-top: 18px;
}

.date-input-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.date-input-wrapper {
    width: 95%;
}
.date-input {
    border-bottom-style: solid !important;
    color: black !important;
}

.terms-agreement-container {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 80px 0 45px;
}
.terms-agreement-container label {
    font-size: 18px;
}
.terms-agreement-container span {
    font-size: 18px;
    color: #9e9e9e;
    margin-left: 7px;
}

.submit-form-btn {
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    width: 50%;
    display: block;
    margin: auto;
}

.contractor-section-label {
    margin-top: 1.5rem;
}

.materialize-textarea {
    font-size: 16px !important;
}

.observations-input {
    margin-top: 50px;
}

.steps.pinned {
    right: 56px;
    left: 56px;
}
.steps.pin-bottom {
    position: static !important;
    top: auto !important;
}

.max-width {
    margin-left: auto;
    margin-right: auto;
    max-width: 1200px;
}

.keyword-images {
    align-items: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.keyword-images .title {
    color: #004880;
    font-size: 23px;
    text-align: center;
    margin: 142px 0 56px;
}
.keyword-images-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin-bottom: 81px;
}
.keyword-image {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    border-radius: 5px;
}
.keyword-image:not(:last-child) {
    margin-right: 41px;
}
.keyword-image img {
    height: 158px;
    width: 248px;
    border-radius: 5px;
}
.keyword-image .text {
    color: #002b4d;
    font-size: 15px;
    margin-top: 16px;
}

.categories-container .title {
    color: #004880;
    font-size: 23px;
    margin: 260px 0 90px;
    text-align: center;
}
.categories-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 210px;
}
.categories-container .category {
    background-color: #eeeeee;
    border-radius: 4px;
    flex: 0 1 22%;
    margin-bottom: 22px;
    margin-right: 30px;
}
.categories-container .category:hover {
    background-color: #c4edff;
}
.categories-container .category-text {
    color: #262626;
    font-size: 15px;
    font-weight: 600;
    padding: 20px 64px;
    text-align: center;
}

.supplier-cta {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.supplier-cta .title {
    color: white;
    font-size: 43px;
    font-weight: 700;
    margin-bottom: 60px;
}
.cta-btn {
    font-size: 28px;
    font-weight: 700;
    padding: 0 76px;
}

.logos-container .title {
    color: #004880;
    font-size: 23px;
    margin: 208px 0 62px;
    text-align: center;
}
.logos-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 260px;
}
.logos-container .logo {
    background-color: #fff;
    flex: 0 1 25%;
    margin-bottom: 24px;
}
.logo .logo-image {
    height: 90px;
}

.no-margin-right {
    margin-right: 0px !important;
}

@media screen and (max-width: 1366px) {
    .hero {
        height: 480px;
    }
}

@media screen and (max-width: 992px) {
    .container {
        width: 95% !important;
    }

    .bold-label {
        font-size: 17px !important;
    }

    .hero {
        flex-direction: column-reverse;
        background-image: none;
        height: fit-content;
    }

    .hero .first-column {
        flex-direction: column;
        justify-content: center;
        width: 100%;
    }
    .hero .first-column-content {
        margin-top: 0px;
    }
    .hero .first-column-content .title {
        line-height: 35px;
        font-size: 32px;
    }
    .hero .first-column-content .subtitle {
        line-height: 20px;
        font-size: 16px;
        margin-bottom: 20px;
    }
    .hero .second-column {
        width: 100%;
        margin-bottom: 27px;
    }
    .hero .second-column .hero-img {
        width: 100%;
    }

    .hero-form-container {
        flex-direction: column;
    }

    .mobile-steps {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 70px;
    }
    .step-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        width: 90%;
        padding: 0 12px;
    }
    .step-content .text {
        line-height: 24px;
        text-align: center;
    }
    .step-content .number {
        font-size: 34px;
        padding: 8px 24px;
        margin-right: 24px;
    }
    .step-content:first-child {
        margin-left: 0px;
    }
    .step-content:nth-child(3) {
        margin-right: 0px;
        width: 90%;
    }
    .step-content:not(:nth-child(3)) {
        border-bottom: 1px solid black;
        padding-bottom: 30px;
    }
    .profiles-container {
        margin-bottom: 0px;
    }
    .profiles-container .input-field {
        width: 100%;
    }

    .attachments-input {
        margin-bottom: 50px;
    }

    .terms-agreement-container {
        margin-top: 30px;
        text-align: center;
        width: 95%;
    }

    .submit-form-btn {
        width: 94%;
    }

    .whatsapp-icon-btn {
        color: #fff;
    }

    .whatsapp-icon-mobile-btn {
        margin: 0 auto;
        width: 86%;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
    }

    .whatsapp-icon-mobile-btn .whatsapp-icon {
        margin: unset;
        width: 23px;
    }
}

@media screen and (max-width: 600px) {
    .btn-container {
        background-color: white;
        box-shadow: 0 5px 7px 0 #c1c1c1;
        margin-bottom: -120px;
        padding: 12px 20px 14px;
        position: relative;
        top: -100px;
        z-index: 4;
        border-radius: 5px;
    }
    .hero .first-column-content .hero-form-container {
        margin-bottom: 0px;
    }
    .hero .first-column-content .btn-container .hero-btn {
        font-size: 18px;
        padding: 7px 18px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .hero .first-column-content .title {
        margin-bottom: 5px;
        font-size: 24px;
    }
    .hero .first-column-content .subtitle {
        margin-bottom: 8px;
    }
    .hero-form-container .input-field {
        margin-top: 8px;
    }

    .phone-btn {
        position: relative;
        top: 50px;
        z-index: 4;
    }
    .max-width {
        margin-left: 20px;
        margin-right: 20px;
    }

    .form-wrapper {
        margin: 0px auto 76px;
    }

    .second-column .title-section {
        position: absolute;
        left: 15%;
    }

    .second-column .title-section .title {
        font-size: 25px;
        font-style: italic;
        font-weight: 700;
        margin-bottom: 12px;
        text-align: left;
        color: #004880;
    }

    .second-column .title-section .subtitle {
        font-size: 18px;
        font-style: italic;
        text-align: left;
        color: #004880;
    }

    .alert {
        margin-top: 20px;
    }
}
</style>
